export default __webpack_public_path__ + "static/24-0521ed8617e19933324b7e920f29b7e5.webp";